import { useMemo } from 'react';
import { accountEmpty } from '../components/SiteHeader/Search/handlers';

export const useEmptyAccountPage = () => {
  const isEmptyAccountPage = useMemo(() => accountEmpty.test(location.search), [location.search]);
  return {
    isEmptyAccountPage,
  };
};
